export default [
    {
        name: 'Contratações',
        url: '/credenciados/fornecedor/contratacoes',
        icon: 'fa fa-book',
        regras: 'CRED-FORN-CONT-00',
        badge: {
            variant: 'primary',
            text: 'SGF'
        }
    },
    {
        name: 'Pagamentos',
        url: '/credenciados/fornecedor/finalizacoes',
        icon: 'fa fa-dollar',
        regras: 'CRED-FORN-FIN-00',
        badge: {
            variant: 'primary',
            text: 'SGF'
        }
    }
]
